module.exports = __webpack_public_path__ + "img/icon_kaitibao.35ba6302.svg";